import { ChartData, ChartOptions } from 'chart.js'
import { Line } from 'react-chartjs-2'
import ChartsHelper from './ChartsHelper'

interface Props {
    data: ChartData<'line', number[], unknown>
    options?: ChartOptions<'line'>
    moreOptions?: ChartOptions<'line'>
    style?: React.CSSProperties
    isLoading?: boolean
}

const SparklineChart = ({ data, options, moreOptions, style, isLoading }: Props) => {
    ChartsHelper.applyColors(data.datasets as any)
    const myOptions = options ?? { ...SparklineChartDefaultOptions, ...moreOptions }

    let chartData = data
    if (isLoading) {
        chartData = {
            datasets: [{
                data: Array(12).fill(0).map(() => Math.random() * 10),
                borderColor: isLoading && 'grey'
            }],
            labels: Array(12).fill(0).map((x, i) => i)
        }
    }

    return (
        <div style={{ ...{ flex: 1 }, ...style }}>
            <Line
                data={chartData}
                width='100%'
                height='100%'
                options={myOptions}
            />
        </div>
    )
}

export default SparklineChart
export const SparklineChartDefaultOptions: ChartOptions<'line'> = {
    maintainAspectRatio: false,
    elements: {
        line: { borderWidth: 2, tension: 0.4 },
        point: { radius: 0 }
    },
    plugins: {
        legend: { display: false },
        tooltip: { enabled: false, callbacks: {} },
        datalabels: { display: false }
    },
    hover: { mode: null },
    animation: { duration: 200 },
    scales: {
        x: {
            display: false
        },
        y: {
            display: false
        }
    }
}
